import React, { useState } from 'react';
import styles from './menus.module.css';
import { prop as p } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';
import { changeEustNr, runTour, toggle_legend } from '../../store/load_data';

const Toggle = ({title,checked}) => <label className={styles.switch}>
  <span className={styles.toggle_title}>{title}</span>
  <input type="checkbox" />
  <span className={styles.slider}></span>
</label>

export const Menus = () => {
  const [wave_open,toggle_wave] = useState(0);
  const [show_confirm, toggle_confirm] = useState(0);
  const [menu_open, toggle_menu] = useState(0);
  const selected_wave = useSelector(p("eust_nr"))
  const dispatch = useDispatch();

  const confirm_copy = () => {
    navigator.clipboard.writeText( window.location.href);
    toggle_confirm(1);
    setTimeout(x => {toggle_confirm(0)},2000);
  }

  return <>
    <div className={styles.menu + (menu_open ?  " "+ styles.open : "")}> 
      <div className={styles.background}></div>
      <div>
        <div className={styles.menucontainer}>
          <a href="/">
            <svg ><use xlinkHref={"#home"}/></svg>
            <span>HOME</span>
          </a>
          <button onClick={() => {dispatch(runTour(true))}}>
            <svg id="tour" ><use xlinkHref={"#tutorial"}/></svg>        
            <span>TUTORIAL</span>
          </button>
          <button className={styles.share_btn} onClick={confirm_copy}>
            <svg ><use xlinkHref={"#share"}/></svg>        
            <span>SHARE</span>
          </button>
          <button onClick={() => {window.print()}}>
            <svg ><use xlinkHref={"#print"}/></svg>        
            <span>PRINT</span>
          </button>
          <button onClick={() => {dispatch(toggle_legend())}}>
            <svg ><use xlinkHref={"#scale"}/></svg>        
            <span>SCALE</span>
          </button>
        </div>
      </div>
      <div>
        <div 
          className={[styles.dropdown,wave_open ? styles.waves_open : ""].join(" ")}
          onClick={x => toggle_wave(!wave_open)}>
          <span className={styles.mobile_text}>SELECT EUROSTUDENT ROUND</span>
          <div className={styles.dropcontent}>{[7,8].map(x => 
              <button 
                key={"wave"+x}
                className={selected_wave === x ? styles.selected_wave : ""}
                onClick={() => {dispatch(changeEustNr(x))}}
              >{x}</button>)}
          </div>
          <span className={styles.text}>ROUND</span>
        </div>
      </div>
    <button 
      onClick={() => toggle_menu(!menu_open)}
      className={styles.menu_toggle}>
      <div className={styles.dot}></div>
      <div className={styles.dot}></div>
      <div className={styles.dot}></div>
      <div className={styles.dot}></div>
    </button>
    </div> 
    <div className={[styles.share_confirm, show_confirm ? styles.visible : ""].join(" ")}>
      Link copied to clipboard!
    </div>
  </>

}